import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import MatchesService from "../../../../../services/MatchesService";
import plus from "../../../../../images/icons/plus.svg";
import edit from "../../../../../images/icons/edit.svg";
import { Translate } from "../../../../Enums/Tranlate";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
	duration_of_the_match,
	matchesTypes,
	months,
	times,
} from "../../../../Enums/Fixed";
import "../style.scss";
import CourtsService from "../../../../../services/CourtsService";
import PlayersModal from "./PlayersModal";

const AddMatches = () => {
	const [formData, setFormData] = useState({
		date: "",
		day: {},
		time: "",
		duration: "",
		court: "",
		level: "beginner",
		price: "",
		is_court_booked: true,
		add_player: [],
		invite_player: [],
		type: "competition",
		tournament_name: "",
		number_of_teams: 1,
		number_of_players: 4,
	});
	const match_types = [
		{ label: "Match Double", value: "double", word: "match_double", player: 4 },
		{
			label: "Single Double",
			value: "single",
			word: "single_double",
			player: 2,
		},
	];
	const [days, setDays] = useState([]);
	const [playerModal, setPlayerModal] = useState(false);
	const [playerType, setPlayerType] = useState("");
	const [courtsOptions, setCourtsOptions] = useState([]);
	const [selectType, setSelectType] = useState("");
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const lang = useSelector((state) => state.auth.lang);
	const matchesService = new MatchesService();

	useEffect(() => {
		let item = location?.state || {};
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setSelectType(item?.kind);
			setFormData({
				id: item?.id,
				date: item?.date?.slice(0, 7),
				day: {
					day: String(
						new Date(
							Number(item?.date?.slice(0, 4)),
							Number(item?.date?.slice(5, 7)) - 1,
							formData?.day?.number
						)
					).slice(0, 3),
					month: months[Number(item?.date?.slice(5, 7)) - 1],
					number: Number(item?.date?.slice(8, 10)),
					year: Number(item?.date?.slice(0, 4)),
				},
				match_type: item?.type,
				time: item?.time,
				duration: item?.duration,
				court: !!item?.court?.name_en
					? {
							label: item?.court[`name_${lang}`],
							value: item?.court_id,
					  }
					: "",
				level: item?.level,
				price: item?.court_price || "",
				is_court_booked: item?.is_court_booked,
				tournament_name: item?.tournament_name,
				number_of_teams:
					item?.tournament_type === "competition" ? item?.number_of_team : 1,
				number_of_players:
					item?.tournament_type !== "competition" ? item?.number_of_team : 4,
				type: item?.tournament_type,
				add_player: !!item?.match_add_players?.length
					? item?.match_add_players?.map((player) => {
							return {
								...player?.web_user,
								label: player?.web_user?.fullname,
								value: player?.web_user?.id,
							};
					  })
					: [],
				invite_player: !!item?.match_invite_players?.length
					? item?.match_invite_players?.map((player) => {
							return {
								...player?.web_user,
								label: player?.web_user?.fullname,
								value: player?.web_user?.id,
							};
					  })
					: [],
			});
			// matchesService.find(item?.kind, item?.id).then((res) => {
			// 	if (res?.status) {
			// 		const response = res?.data?.data;
			// 	}
			// });
		}

		new CourtsService().getList().then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data?.map((court) => {
					return {
						label: court[`name_${lang}`],
						value: court?.id,
					};
				});
				setCourtsOptions(response);
			}
		});
	}, []);

	const initialDates = () => {
		if (!!formData?.date) {
			const currentMonth = new Date().getMonth() + 1;
			const [year, month] = formData?.date?.split("-").map(Number);
			const date = new Date(year, month, 0);
			const totalDays = date.getDate();
			const currentDay = new Date().getUTCDate();
			let startDay = currentMonth === month ? currentDay : 1;
			let result = [];

			for (let i = startDay; i <= totalDays; i++) {
				const d = new Date(year, month - 1, i);
				result.push({
					day: String(d).slice(0, 3),
					number: i,
					month: months[d.getMonth()],
					year: year,
				});
			}
			if (!isAdd) {
				let currentDateSelected = {
					...formData?.day,
					day: String(new Date(year, month - 1, formData?.day?.number)).slice(
						0,
						3
					),
				};
				if (
					!result?.some(
						(item) =>
							item?.day === currentDateSelected?.day &&
							item?.month === currentDateSelected?.month &&
							item?.number === currentDateSelected?.number &&
							item?.year === currentDateSelected?.year
					)
				) {
					result.unshift(currentDateSelected);
				}
			}
			setDays(result);
		}
	};

	useEffect(() => {
		initialDates();
	}, [formData?.date]);

	const submit = (e) => {
		e.preventDefault();
		if (
			!formData?.court ||
			(selectType !== "tournament" && !formData?.match_type) ||
			!formData?.duration ||
			!formData?.time ||
			!formData?.date ||
			!formData?.day
		) {
			return;
		}
		let data = {
			date: `${formData?.date}-${
				formData?.day?.number < 10
					? `0${formData?.day?.number}`
					: formData?.day?.number
			}T00:00:00`,
			time: formData?.time,
			duration: formData?.duration,
			court_id: formData?.court?.value,
			level: formData?.level,
			is_court_booked: formData?.is_court_booked,
		};
		if (!!formData?.price) data["court_price"] = formData?.price;
		if (!!formData?.note) data["note"] = formData?.note;
		if (selectType !== "tournament") {
			data["type"] = formData?.match_type;
		}
		if (selectType === "private") {
			if (!!formData?.add_player?.length)
				data["add_player_id"] = formData?.add_player?.map((res) => res?.value);
			if (!!formData?.invite_player?.length)
				data["invite_player_id"] = formData?.invite_player?.map(
					(res) => res?.value
				);
		}
		if (selectType === "tournament") {
			data["tournament_type"] = formData?.type;
			data["number_of_team"] =
				formData?.type === "competition"
					? formData?.number_of_teams
					: formData?.number_of_players;
			data["tournament_name"] = formData?.tournament_name;
		}

		setLoading(true);
		if (isAdd) {
			matchesService
				.create(selectType, data)
				?.then((res) => {
					if (res?.status === 201) {
						toast.success(res?.data?.message);
						navigate("/matches");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			matchesService
				.update(selectType, formData?.id, data)
				?.then((res) => {
					if (res?.status === 200) {
						toast.success(res?.data?.message);
						navigate("/matches");
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const submitFu = (data) => {
		if (playerType === "add") {
			setFormData((prev) => ({ ...prev, add_player: data }));
		} else {
			setFormData((prev) => ({ ...prev, invite_player: data }));
		}
	};

	return (
		<>
			<div
				className="d-flex align-items-center"
				style={{ gap: "8px", margin: "12px 0 32px" }}>
				<svg
					style={{ cursor: "pointer" }}
					width="24"
					height="24"
					className="button-back"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					onClick={() => navigate("/matches")}>
					<path
						d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.4999 12H3.66992"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<label className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
					{!isAdd ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
					{Translate[lang]?.match}
				</label>

				{/* <Form.Check
					type="switch"
					id="custom-switch"
					checked={formData?.isActive}
					onChange={(e) =>
						setFormData({ ...formData, isActive: e.target.checked })
					}
				/> */}
			</div>
			<AvForm
				className="form-horizontal add-matches w-75"
				onValidSubmit={submit}>
				<Row>
					{isAdd &&
						matchesTypes?.map((type) => {
							return (
								<Col md={4} key={type?.label}>
									<div
										onClick={() => setSelectType(type?.label)}
										className={
											selectType === type?.label ? "active type" : "type"
										}>
										{type?.icon}
										<p className="mb-0">{Translate[lang][type?.label]}</p>
									</div>
								</Col>
							);
						})}
					{selectType === "private" && (
						<Col md={12} className="mb-3">
							<div className="players">
								{!formData?.add_player?.length ? (
									<Button
										variant="outline-primary"
										type="button"
										onClick={() => {
											setPlayerModal(true);
											setPlayerType("add");
										}}
										style={{
											height: "40px",
										}}
										className="w-100 d-flex gap-8 justify-content-center">
										<img src={plus} alt="plus" />
										{Translate[lang].add} {Translate[lang].players}
									</Button>
								) : (
									<div
										className="w-100 p-3"
										style={{ boxShadow: "0px 0px 12px 0px #0000001a" }}>
										<div className="d-flex justify-content-between mb-3">
											<p className="mb-0">
												{Translate[lang].add} {Translate[lang].players}
											</p>
											<img
												src={edit}
												alt="edit"
												className="cursor-pointer"
												onClick={() => {
													setPlayerModal(true);
													setPlayerType("add");
												}}
											/>
										</div>
										{formData?.add_player?.map((player) => {
											return (
												<div
													key={player?.id}
													className="d-flex mb-3 gap-16 align-items-center">
													{!!player?.avatar ? (
														<img
															src={player?.avatar}
															alt="avatar"
															width={32}
															height={32}
														/>
													) : (
														<span className="avatar"></span>
													)}
													<p className="mb-0">{player?.fullname}</p>
												</div>
											);
										})}
									</div>
								)}
								{!formData?.invite_player?.length ? (
									<Button
										variant="outline-primary"
										type="button"
										style={{
											height: "40px",
										}}
										onClick={() => {
											setPlayerModal(true);
											setPlayerType("invite");
										}}
										className="w-100 d-flex gap-8 justify-content-center">
										<img src={plus} alt="plus" />
										{Translate[lang].invite} {Translate[lang].players}
									</Button>
								) : (
									<div
										className="w-100 p-3"
										style={{ boxShadow: "0px 0px 12px 0px #0000001a" }}>
										<div className="d-flex justify-content-between mb-3">
											<p className="mb-0">
												{Translate[lang].invite} {Translate[lang].players}
											</p>
											<img
												src={edit}
												alt="edit"
												className="cursor-pointer"
												onClick={() => {
													setPlayerModal(true);
													setPlayerType("invite");
												}}
											/>
										</div>
										{formData?.invite_player?.map((player) => {
											return (
												<div
													key={player?.id}
													className="d-flex mb-3 gap-16 align-items-center">
													{!!player?.avatar ? (
														<img
															src={player?.avatar}
															alt="avatar"
															width={32}
															height={32}
														/>
													) : (
														<span className="avatar"></span>
													)}
													<p className="mb-0">{player?.fullname}</p>
												</div>
											);
										})}
									</div>
								)}
							</div>
						</Col>
					)}
					{selectType === "tournament" && (
						<Col md={12} className="mb-3 d-flex gap-16">
							<p
								onClick={() =>
									setFormData((prev) => ({ ...prev, type: "competition" }))
								}
								className={
									formData?.type === "competition"
										? "active type w-100"
										: "type w-100"
								}>
								{Translate[lang].competition}
							</p>
							<p
								onClick={() =>
									setFormData((prev) => ({ ...prev, type: "americano" }))
								}
								className={
									formData?.type === "americano"
										? "active type w-100"
										: "type w-100"
								}>
								{Translate[lang].americano}
							</p>
						</Col>
					)}
					{!!selectType && (
						<Col md={12}>
							<div className="d-flex justify-content-between align-items-center mb-3">
								<p className="fw-bold fs-14 text-black mb-0">
									{Translate[lang].date}
								</p>
								<input
									type="month"
									className="month"
									min={new Date().toISOString().slice(0, 7)}
									value={formData?.date}
									onChange={(e) =>
										setFormData((prev) => ({
											...prev,
											date: e.target.value,
											day: {},
										}))
									}
								/>
							</div>
							<div className="daysShown">
								{days?.map((day) => {
									return (
										<div
											onClick={() =>
												setFormData((prev) => ({ ...prev, day: day }))
											}
											className={
												formData?.day?.number === day?.number &&
												formData?.day?.year === day?.year &&
												formData?.day?.month === day?.month
													? "active day"
													: "day"
											}
											key={day?.number}>
											<p className="fw-bold">{day?.day}</p>
											<p>{day?.number}</p>
											<p>{day?.month}</p>
										</div>
									);
								})}
							</div>
						</Col>
					)}
					{!!formData?.day?.day && (
						<Col md={12}>
							<div className="d-flex justify-content-between align-items-center mb-2">
								<p className="fw-bold fs-14 text-black mb-0">
									{Translate[lang].time}
								</p>
							</div>
							<div className="timesShown">
								{times?.map((time) => {
									return (
										<div
											onClick={() =>
												setFormData((prev) => ({ ...prev, time: time }))
											}
											className={
												formData?.time === time ? "active time" : "time"
											}
											key={time}>
											<p className="fw-bold mb-0">{time}</p>
										</div>
									);
								})}
							</div>
						</Col>
					)}
					{!!formData?.time && (
						<Col md={12}>
							<div className="d-flex justify-content-between align-items-center mb-2">
								<p className="fw-bold fs-14 text-black mb-0">
									{Translate[lang].duration_of_the_match}
								</p>
							</div>
							<div className="timesShown">
								{duration_of_the_match?.map((duration) => {
									return (
										<div
											onClick={() =>
												setFormData((prev) => ({ ...prev, duration: duration }))
											}
											className={
												formData?.duration === duration ? "active time" : "time"
											}
											key={duration}>
											<p className="fw-bold mb-0">{duration}</p>
										</div>
									);
								})}
							</div>
						</Col>
					)}
					{!!formData?.duration && selectType !== "tournament" && (
						<Col md={12}>
							<div className="d-flex justify-content-between align-items-center mb-2">
								<p className="fw-bold fs-14 text-black mb-0">
									{Translate[lang].match_type}
								</p>
							</div>
							<div className="d-flex gap-16">
								{match_types?.map((type) => {
									return (
										<div key={type?.label}>
											<div
												onClick={() =>
													setFormData((prev) => ({
														...prev,
														match_type: type?.value,
													}))
												}
												className={
													formData?.match_type === type?.value
														? "active type"
														: "type"
												}>
												<svg
													width="15"
													height="18"
													viewBox="0 0 15 18"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														fillRule="evenodd"
														clipRule="evenodd"
														d="M11.7424 6.56061C11.7424 8.67804 10.2928 10.4515 8.33334 10.9568V14.894H10.6061C10.8155 14.894 10.9849 15.0637 10.9849 15.2727C10.9849 15.4822 10.8155 15.6515 10.6061 15.6515H3.78788C3.57841 15.6515 3.4091 15.4822 3.4091 15.2727C3.4091 15.0637 3.57841 14.894 3.78788 14.894H6.06061V10.9568C4.10114 10.4515 2.65152 8.67804 2.65152 6.56061C1.18712 6.56061 0 5.37349 0 3.9091V3.15152C0 2.94243 0.169318 2.77273 0.378788 2.77273H2.65152V2.39394C2.65152 1.76629 2.14281 1.25758 1.51515 1.25758C1.30568 1.25758 1.13637 1.08788 1.13637 0.878788C1.13637 0.669697 1.30568 0.5 1.51515 0.5H12.8788C13.0883 0.5 13.2576 0.669697 13.2576 0.878788C13.2576 1.08788 13.0883 1.25758 12.8788 1.25758C12.2512 1.25758 11.7424 1.76629 11.7424 2.39394V2.77273H14.0152C14.2246 2.77273 14.394 2.94243 14.394 3.15152V3.9091C14.394 5.37349 13.2068 6.56061 11.7424 6.56061ZM6.81819 14.894H7.57577V11.0868C7.45077 11.0974 7.32501 11.1061 7.19698 11.1061C7.06895 11.1061 6.94319 11.0974 6.81819 11.0868V14.894ZM0.757577 3.53031V3.9091C0.757577 4.95531 1.60531 5.80304 2.65152 5.80304V3.53031H0.757577ZM3.02197 1.25758C3.26137 1.575 3.4091 1.96553 3.4091 2.39394V6.56061C3.4091 8.65266 5.10493 10.3485 7.19698 10.3485C9.28865 10.3485 10.9849 8.65266 10.9849 6.56061V2.39394C10.9849 1.96553 11.1326 1.575 11.372 1.25758H3.02197ZM13.6364 3.53031H11.7424V5.80304C12.7887 5.80304 13.6364 4.95531 13.6364 3.9091V3.53031ZM2.65152 16.4091H11.7424C11.9519 16.4091 12.1212 16.5788 12.1212 16.7879C12.1212 16.9974 11.9519 17.1667 11.7424 17.1667H2.65152C2.44205 17.1667 2.27273 16.9974 2.27273 16.7879C2.27273 16.5788 2.44205 16.4091 2.65152 16.4091Z"
														fill="black"
													/>
												</svg>

												<p className="mb-0 fs-14">
													{Translate[lang][type?.word]}
												</p>
												<p className="mb-0 fs-12" style={{ color: "#7B7B7B" }}>
													{type?.player} {Translate[lang].players}
												</p>
											</div>
										</div>
									);
								})}
							</div>
						</Col>
					)}
					{(!!formData?.match_type ||
						(selectType === "tournament" && !!formData?.duration)) && (
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.court}</label>
							<Select
								value={formData?.court}
								name="court"
								placeholder={Translate[lang]?.select}
								options={courtsOptions}
								onChange={(e) => setFormData({ ...formData, court: e })}
							/>
						</Col>
					)}
					{!!formData?.court && (
						<Col md={12} className="mb-3 level">
							<label className="text-label">{Translate[lang]?.level}</label>
							<div className="d-flex align-items-center gap-16">
								<label
									htmlFor="beginner"
									className="d-flex align-items-center gap-8 mb-0">
									<input
										type="radio"
										name="level"
										id="beginner"
										checked={formData?.level === "beginner"}
										onChange={() =>
											setFormData((prev) => ({ ...prev, level: "beginner" }))
										}
									/>
									{Translate[lang].beginner}
								</label>
								<label
									htmlFor="intermediate"
									className="d-flex align-items-center gap-8 mb-0">
									<input
										type="radio"
										name="level"
										id="intermediate"
										checked={formData?.level === "intermediate"}
										onChange={() =>
											setFormData((prev) => ({
												...prev,
												level: "intermediate",
											}))
										}
									/>
									{Translate[lang].intermediate}
								</label>
								<label
									htmlFor="advanced"
									className="d-flex align-items-center gap-8 mb-0">
									<input
										type="radio"
										name="level"
										id="advanced"
										checked={formData?.level === "advanced"}
										onChange={() =>
											setFormData((prev) => ({ ...prev, level: "advanced" }))
										}
									/>
									{Translate[lang].advanced}
								</label>
							</div>
						</Col>
					)}
					{!!formData?.court && selectType === "tournament" && (
						<Col md={12} className="mb-3">
							<label className="text-label">
								{formData?.type === "competition"
									? Translate[lang]?.number_of_teams
									: Translate[lang]?.number_of_players}{" "}
								<span className="fs-12" style={{ color: "#7B7B7B" }}>
									{formData?.type === "competition"
										? `(${Translate[lang].max} ${lang === "en" ? 20 : "٢٠"})`
										: `(${Translate[lang].min} ${lang === "en" ? 4 : "٤"}, ${
												Translate[lang].max
										  } ${lang === "en" ? 12 : "١٢"})`}
								</span>
							</label>
							<div className="numOfPlayers d-flex align-items-center justify-content-between">
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									onClick={() => {
										if (
											formData?.number_of_teams > 1 &&
											formData?.type === "competition"
										) {
											setFormData((prev) => ({
												...prev,
												number_of_teams: prev?.number_of_teams - 1,
											}));
										}
										if (
											formData?.number_of_players > 4 &&
											formData?.type !== "competition"
										) {
											setFormData((prev) => ({
												...prev,
												number_of_players: prev?.number_of_players - 1,
											}));
										}
									}}
									className={
										(formData?.number_of_teams === 1 &&
											formData?.type === "competition") ||
										(formData?.number_of_players === 4 &&
											formData?.type !== "competition")
											? ""
											: "cursor-pointer"
									}
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
										fill={
											(formData?.number_of_teams === 1 &&
												formData?.type === "competition") ||
											(formData?.number_of_players === 4 &&
												formData?.type !== "competition")
												? "#E3E3E3"
												: "#C8202F"
										}
									/>
								</svg>

								<span>
									{formData?.type === "competition"
										? formData?.number_of_teams
										: formData?.number_of_players}
								</span>
								<svg
									width="24"
									height="24"
									className={
										formData?.number_of_teams ===
										(formData?.type === "competition" ? 20 : 12)
											? ""
											: "cursor-pointer"
									}
									onClick={() => {
										if (
											formData?.number_of_teams < 20 &&
											formData?.type === "competition"
										) {
											setFormData((prev) => ({
												...prev,
												number_of_teams: prev?.number_of_teams + 1,
											}));
										}
										if (
											formData?.number_of_players < 12 &&
											formData?.type !== "competition"
										) {
											setFormData((prev) => ({
												...prev,
												number_of_players: prev?.number_of_players + 1,
											}));
										}
									}}
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM18 12.75H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
										fill={
											(formData?.number_of_teams === 20 &&
												formData?.type === "competition") ||
											(formData?.number_of_players === 12 &&
												formData?.type !== "competition")
												? "#E3E3E3"
												: "#C8202F"
										}
									/>
								</svg>
							</div>
						</Col>
					)}
					{!!formData?.court && selectType === "tournament" && (
						<Col md={12} className="mb-3 level">
							<label className="text-label">
								{Translate[lang]?.tournament_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.tournament_name}
								bsSize="lg"
								name="tournament_name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.tournament_name}
								onChange={(e) =>
									setFormData({
										...formData,
										tournament_name: e.target.value,
									})
								}
							/>
						</Col>
					)}
					{!!formData?.court && (
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.note} ({Translate[lang].optional})
							</label>
							<AvField
								type="textarea"
								placeholder={Translate[lang]?.note}
								bsSize="lg"
								name="note"
								style={{
									height: "100px",
								}}
								value={formData.note}
								onChange={(e) =>
									setFormData({
										...formData,
										note: e.target.value,
									})
								}
							/>
						</Col>
					)}
					{!!formData?.court && (
						<Col md={12}>
							<label className="text-label">
								{selectType === "tournament"
									? formData?.type === "competition"
										? Translate[lang]?.court_price_team
										: Translate[lang]?.court_price_player
									: Translate[lang]?.price}{" "}
								({Translate[lang].optional})
							</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.price}
								bsSize="lg"
								name="price"
								value={formData.price}
								onChange={(e) =>
									setFormData({
										...formData,
										price: e.target.value,
									})
								}
							/>
						</Col>
					)}
					{!!formData?.court && (
						<Col md={12} className="mb-3 level">
							<label className="text-label">
								{Translate[lang]?.is_court_booked}
							</label>
							<div className="d-flex align-items-center gap-16">
								<label
									htmlFor="yes"
									className="d-flex align-items-center gap-8 mb-0">
									<input
										type="radio"
										name="is_court_booked"
										id="yes"
										checked={formData?.is_court_booked}
										onChange={() =>
											setFormData((prev) => ({
												...prev,
												is_court_booked: true,
											}))
										}
									/>
									{Translate[lang].yes}
								</label>
								<label
									htmlFor="no"
									className="d-flex align-items-center gap-8 mb-0">
									<input
										type="radio"
										name="is_court_booked"
										id="no"
										checked={!formData?.is_court_booked}
										onChange={() =>
											setFormData((prev) => ({
												...prev,
												is_court_booked: false,
											}))
										}
									/>
									{Translate[lang].no}
								</label>
							</div>
						</Col>
					)}
				</Row>

				<Button
					variant="primary"
					type="submit"
					className="w-100"
					disabled={loading}>
					{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
					{Translate[lang]?.match}
				</Button>
			</AvForm>
			{playerModal && (
				<PlayersModal
					modal={playerModal}
					item={formData}
					setModal={() => setPlayerModal(false)}
					submitFu={(data) => submitFu(data)}
					text={playerType}
				/>
			)}
		</>
	);
};

export default AddMatches;
